<template>
  <NoteList
            :change-permission="'change_auction'"
            :delete-permission="'delete_auction'"
            :object-uuid="sale.uuid" plural-object-name="auctions" object-name="auction"/>
</template>

<script>
  import NoteList from "./../../../notes/NotesList";
  import {createNamespacedHelpers} from "vuex";

  const {mapState} = createNamespacedHelpers('sales');

  export default {
    name: "Notes",
    components: {NoteList},
    computed: {
      ...mapState({
        sale: state => state.view.currentSale,
      }),
    },
  }
</script>

<style scoped>

</style>
